<!--<h1>{{IsShowDetail}}</h1>-->
<div *ngIf='!IsShowDetail'>
  <div class="modal-header">
    <h4 class="modal-title">Employment History</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <!-- Form actions layout section start -->
    <section id="form-action-layouts">


      <div class="row justify-content-md-center">
        <div class="col-md-12">
          <div class="card">

            <div class="card-body">
              <div class="px-3">
                <form class="form" novalidate="" (ngSubmit)="onSubmit()" #f="ngForm">


                  <div class="form-body">


                    <div class="row">
                      <div class="form-group col-12 mb-2">
                        <label for="eventInput2">Employer</label>
                        <input type="text" class="form-control" id="CurrentActorEmpHistoryInfoRequest.EmployerName"
                               [(ngModel)]="CurrentActorEmpHistoryInfoRequest.EmployerName"
                               name="CurrentActorEmpHistoryInfoRequest.EmployerName" placeholder="EmployerName" required>
                      </div>
                    </div>


                    <div class="row">
                      <div class="form-group col-12 mb-2">
                        <label for="eventInput4">Duties</label>
                        <input type="text" class="form-control" id="CurrentActorEmpHistoryInfoRequest.Duties"
                               [(ngModel)]="CurrentActorEmpHistoryInfoRequest.Duties"
                               name="CurrentActorEmpHistoryInfoRequest.Duties" placeholder="Duties" required>
                      </div>
                    </div>

                    <div class="row">
                      <div class="form-group col-12 mb-2">
                        <label for="eventInput5">Responsibilities</label>
                        <input type="text" class="form-control" id="CurrentActorEmpHistoryInfoRequest.Responsibilities"
                               [(ngModel)]="CurrentActorEmpHistoryInfoRequest.Responsibilities"
                               name="CurrentActorEmpHistoryInfoRequest.Responsibilities" placeholder="Responsibilities" required>
                      </div>
                    </div>
                    <div class="row">
                      <div class="form-group col-12 mb-2">
                        <label for="eventInput5">Still Working </label>
                        <input type="checkbox" class="form-control" id="CurrentActorEmpHistoryInfoRequest.IsCurrent"
                               [(ngModel)]="CurrentActorEmpHistoryInfoRequest.IsCurrent" name="CurrentActorEmpHistoryInfoRequest.IsCurrent" placeholder="IsCurrent">
                      </div>
                    </div>

                    <div class="row">
                      <div class="form-group col-12 mb-2">
                        <label for="eventInput5">From Date</label>
                        <input type="date" class="form-control" id="CurrentActorEmpHistoryInfoRequest.FromDate"
                               [(ngModel)]="CurrentActorEmpHistoryInfoRequest.FromDate"
                               name="CurrentActorEmpHistoryInfoRequest.FromDate" placeholder="FromDate">
                      </div>
                    </div>
                    <div class="row">
                      <div class="form-group col-12 mb-2">
                        <label for="eventInput5">To Date</label>
                        <input type="date" class="form-control" id="CurrentActorEmpHistoryInfoRequest.ToDate"
                               [(ngModel)]="CurrentActorEmpHistoryInfoRequest.ToDate"
                               name="CurrentActorEmpHistoryInfoRequest.ToDate" placeholder="ToDate">
                      </div>
                    </div>

                    <div class="row">
                      <div class="form-group col-12 mb-2">
                        <label for="eventInput5">Supervisor Title</label>
                        <input type="text" class="form-control"
                               id="CurrentActorEmpHistoryInfoRequest.SupervisorTitle"
                               [(ngModel)]="CurrentActorEmpHistoryInfoRequest.SupervisorTitle"
                               name="CurrentActorEmpHistoryInfoRequest.SupervisorTitle" placeholder="SupervisorTitle">
                      </div>
                    </div>
                    <div class="row">
                      <div class="form-group col-12 mb-2">
                        <label for="eventInput5">Supervisor Name</label>
                        <input type="text" class="form-control"
                               id="CurrentActorEmpHistoryInfoRequest.SupervisorName"
                               [(ngModel)]="CurrentActorEmpHistoryInfoRequest.SupervisorName"
                               name="CurrentActorEmpHistoryInfoRequest.SupervisorName" placeholder="SupervisorName">
                      </div>
                    </div>
                   
                    <div class="row">
                      <div class="form-group col-12 mb-2">
                        <label for="eventInput5">May We Contact</label>
                        <input type="checkbox" class="form-control"
                               id="CurrentActorEmpHistoryInfoRequest.MayContact"
                               [(ngModel)]="CurrentActorEmpHistoryInfoRequest.MayContact"
                               name="CurrentActorEmpHistoryInfoRequest.SupervisorName" placeholder="MayContact">
                      </div>
                    </div>
                    <div class="row">
                      <div class="form-group col-12 mb-2">
                        <label for="eventInput5">Phone No</label>
                        <input type="text" class="form-control"
                               id="CurrentActorEmpHistoryInfoRequest.PhoneNo"
                               [(ngModel)]="CurrentActorEmpHistoryInfoRequest.PhoneNo"
                               name="CurrentActorEmpHistoryInfoRequest.PhoneNo" placeholder="PhoneNo">
                      </div>
                    </div>
                    <div class="row">
                      <div class="form-group col-12 mb-2">
                        <label for="eventInput5">Address</label>
                        <input type="text" class="form-control"
                               id="CurrentActorEmpHistoryInfoRequest.Address"
                               [(ngModel)]="CurrentActorEmpHistoryInfoRequest.Address"
                               name="CurrentActorEmpHistoryInfoRequest.Address" placeholder="Address">
                      </div>
                    </div>
                    <div class="row">
                      <div class="form-group col-12 mb-2">
                        <label for="eventInput5">Reason For Leaving</label>
                        <input type="text" class="form-control"
                               id="CurrentActorEmpHistoryInfoRequest.ReasonForLeaving"
                               [(ngModel)]="CurrentActorEmpHistoryInfoRequest.ReasonForLeaving"
                               name="CurrentActorEmpHistoryInfoRequest.ReasonForLeaving" placeholder="ReasonForLeaving">
                      </div>
                    </div>

                    <div class="form-group">
                      <div class="col-md-12">
                        <button type="submit" [disabled]="!f.valid" *ngIf='!isRequesting' class="btn btn-pink btn-block btn-raised">Submit</button>

                      </div>
                    </div>


                  </div>


                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- // Form actions layout section end -->
  </div>


  <div class="modal-footer">
    <button type="button" class="btn btn-secondary btn-raised" (click)="activeModal.close('Close click')">Close</button>
  </div>
</div>
<div *ngIf='IsShowDetail'>
  <div class="modal-header">
    <h4 class="modal-title">Employee History Info</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <!-- Form actions layout section start -->
    <section id="form-action-layouts">


      <div class="row justify-content-md-center">
        <div class="col-md-12">
          <div class="card">

            <div class="card-body">
              <div class="px-3">
                <detail-grid *ngIf="CurrentActorEmpHistoryInfoControllerByCode"
                             [columns]="dcolumns" [data]="CurrentActorEmpHistoryInfoControllerByCode">

                </detail-grid>

              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- // Form actions layout section end -->
  </div>


  <div class="modal-footer">
    <button type="button" class="btn btn-secondary btn-raised" (click)="activeModal.close('Close click')">Close</button>
  </div>
</div>
